import { KeenSliderPlugin } from 'keen-slider/react';

const DEFAULT_MOVE_SLIDE_MS = 5000;

export const AutoSlidePlugin = (
  interval = DEFAULT_MOVE_SLIDE_MS,
): KeenSliderPlugin => {
  return slider => {
    let timeout: ReturnType<typeof setTimeout>;

    function clearNextTimeout() {
      clearTimeout(timeout);
    }

    function nextTimeout() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        slider.moveToIdx(slider.track.details.abs + 1, true);
      }, interval);
    }

    slider.on('created', nextTimeout);
    slider.on('dragStarted', clearNextTimeout);
    slider.on('animationStarted', clearNextTimeout);
    slider.on('animationEnded', nextTimeout);
    slider.on('updated', nextTimeout);
    slider.on('destroyed', clearNextTimeout);
  };
};
